import { render } from "./addTransfer.vue?vue&type=template&id=66900b4f&scoped=true"
import script from "./addTransfer.vue?vue&type=script&lang=js"
export * from "./addTransfer.vue?vue&type=script&lang=js"

import "./addTransfer.vue?vue&type=style&index=0&id=66900b4f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66900b4f"]])

export default __exports__